module.exports = __webpack_public_path__ + "img/mute.7d0c88ee.svg";